/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum LogLevel {
  Error = 1,
  Warning = 2,
  Info = 4,
  Debug = 8,
}
